'use strict';

var NumberModel = require('./number.model');
var NestedModel = require('../../modules/models/nested_model');

module.exports = NestedModel.extend({
    nestedProps: {
        matched: NumberModel,
        total: NumberModel,
    },
});
